import { TextInput } from "@mantine/core";
import DocumentUpload from "../common/Inputs/DocumentUpload";

interface Props {
  file: any;
  name: string;
  setFile: (file: any) => void;
  setName: (name: any) => void;
  isRequiredDoc?: boolean;
}

const DocumentUploadCard = ({ file, name, setFile, setName, isRequiredDoc }: Props) => {
  return (
    <div style={{ border: "1px solid #e5e7eb", borderRadius: "8px", padding: "16px", display: "flex", flexDirection: "column", gap: "12px" }}>
      <TextInput
        label="Dosya Adı"
        value={name}
        onChange={(e) => setName(e.currentTarget.value)}
        readOnly={isRequiredDoc}
      />
      <DocumentUpload onFileSelect={setFile} />
    </div>
  );
};

export default DocumentUploadCard;